import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Footer.scss";
import facebook from "../images/redes/Caralibro.svg"
import Instagram from "../images/redes/Instagram.svg"
import tiktok from "../images/redes/Tik tok.svg"
import youtube from "../images/redes/youtube.svg"
import appStore from "../images/App.svg"
import logo from "../images/logo.png"

const Footer = () => {

  return (
    <footer id="contacto">
        <div className="containerFooter">

            <div className="column1">
                <a href="./index.php"><img src={logo} alt="Logo Coorporativo Salcedo"/></a>
                <div className="containerTextColumn1">
                    <p>Somos un equipo especializado en impulsar tu negocio en el entorno digital. Ofrecemos soluciones personalizadas en diseño web, redes sociales, creación de contenido y más, para ayudarte a crecer y alcanzar tus objetivos.</p>
                </div>
            </div>

            <div className="column2">
                <div>
                    <p>NOSOTROS</p>
                    <div className="textColumn2">
                        <a href="#inicio"><span>Conócenos</span></a><br/>
                        <a href="#porqueE"><span>¿Porque elegirnos?</span></a><br/>
                    </div>
                </div><br/>
                <div>
                    <p>DATOS DE CONTACTO</p>
                    <div className="textColumn2">
                        <a href="mailto:info@real-result.com"><span>info@real-result.com</span></a><br/>
                        <a href="tel:+5215531827432"><span>55 3182 7432</span></a>
                    </div>
                </div>
            </div>
            
            <div className="column3">
                <div>
                    <p>SERVICIOS</p>
                    <div className="textColumn3">
                        <a href="#servicio1"><span>Creación de Video</span></a><br/>
                        <a href="#servicio4"><span>Landing Page</span></a><br/><br/>
                        <span className="ubicacionTitle">CONTÁCTANOS</span><br/>
                        <a href="https://wa.me/5215578714756?text=Me%20puede%20dar%20más%20información%20de%20sus%20servicios" target="blank"><span id="ubicacion">Envíanos un mensaje</span></a><br/>
                        
                    </div>
                </div>
            </div>

            <div className="column4">
                <div>
                    <p>APPS</p>
                    <div>
                        <span>Proximamente</span>
                    </div>
                    <div className="containerImgApp">
                        <img src={appStore} alt=""/>
                    </div>
                </div>
                
                <div className="containerRedes">
                    <Fade cascade="true" direction="left"><a href="https://www.facebook.com/profile.php?id=61570065419857"><img src={facebook} alt="Facebook Real Result"/></a></Fade>
                    <Fade cascade="true" direction="left"><a href="https://www.instagram.com/real__result?igsh=MXBobndnYzJya3hu"><img src={Instagram} alt="Instagram Real Result"/></a></Fade>
                    <Fade cascade="true" direction="left"><a href="https://www.tiktok.com/@real.result"><img src={tiktok} alt="Instagram Real Result"/></a></Fade>
                    <Fade cascade="true" direction="left"><a href="https://www.youtube.com/@RealResultDigitalSuccess"><img src={youtube} alt="Instagram Real Result"/></a></Fade>
                </div>
            </div>

        </div>
</footer>
  );
};

export default Footer;

